import api from './api';

export const getSupervisorsApi = params => {
  return api.get('/users/supervisor', {params});
};

export const getSupervisorDetailsApi = id => {
  return api.get(`users/supervisor/${id}`);
};

export const addSupervisorApi = params => {
  return api.post('/users/supervisor', params);
};

export const editSupervisorApi = params => {
  return api.put('/users/supervisor', params);
};

export const deleteSupervisorApi = id => {
  return api.delete(`/users/supervisor/${id}`);
};
